import React, { useEffect, useState } from 'react'
import { Modal, Button, Form, Input, message, DatePicker, Row, Col, Select, ConfigProvider } from 'antd';
import 'antd/dist/antd.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import api from '../../services/api';
import * as ModalStatusAction from '../../redux/actions/modalStatus'

interface ModalNovoFeriadoProps {
    modalStatus?: any,
    setNovoModuloModal?: any
    setEditarModuloModal?: any
}

const ModalModulo: React.FC<ModalNovoFeriadoProps> = (prop) => {

    let visible = prop.modalStatus[0].visibleNovoModulo || prop.modalStatus[0].visibleEditarModulo

    const [form] = Form.useForm();
    const [moduloID, setModuloID] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        form.resetFields();
        if (prop.modalStatus[0].modulo != null) {
            
            form.setFieldsValue({             
                nome: prop.modalStatus[0].modulo.nome,
                ativo: prop.modalStatus[0].modulo.ativo? '1': '0',
                navegarURL: prop.modalStatus[0].modulo.navegarURL,
                possuiMenu: prop.modalStatus[0].modulo.possuiMenu?'1':'0'

            })
            setModuloID(prop.modalStatus[0].modulo.moduloID);
        }
        
    }, [visible])
  
    const handleCancel = () => {
        if (prop.modalStatus[0].visibleNovoModulo) {
        prop.setNovoModuloModal(false)
        }
        else 
        prop.setEditarModuloModal(false, null)
    };

    const onFinish = async (values: any) => {
        if (prop.modalStatus[0].visibleNovoModulo) {

            setLoading(true);
            await api.post(`Modulo`, {
                Nome: values.nome,
                Ativo: values.ativo === '1' ? true : false,
                PossuiMenu: values.possuiMenu === '1' ? true : false,
                NavegarURL: values.navegarURL
            })
                .then((response) => {
                    message.success('Modulo salvo com sucesso')
                    prop.setNovoModuloModal(false);
                })
                .catch((err) => {
                    message.error('Falha na requisição')

                })
                .finally(() => { 
                    setLoading(false);
                })
        }
        else if (prop.modalStatus[0].visibleEditarModulo) {
            await  api.put(`Modulo`, {
                ModuloID: moduloID,
                Nome: values.nome,
                Ativo: values.ativo === '1' ? true : false,
                PossuiMenu: values.possuiMenu === '1' ? true: false,
                NavegarURL: values.navegarURL
            })
                .then((response) => {
                    message.success('Modulo salvo com sucesso')
                     
                     api.get(`Modulo/porperfil?perfilID=${sessionStorage.getItem('grupoID')}`).then((response) => {
                        sessionStorage.setItem('modulos', JSON.stringify(response.data));
                     })
                })
                .catch((err) => {
                    message.error('Falha na requisição')

                })
                .finally(() => {
                    setLoading(false);
                    setTimeout(() => {                                  
                        prop.setEditarModuloModal(false);
                    });
                })
        }

       

    };

    const onFinishFailed = (errorInfo: any) => {
    };

    return (
        <Modal
            visible={visible}
            title="Módulo"
            onCancel={handleCancel}
            footer={null}
            className="NoneUpperCase"
        >
            <Form
                name="basic"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
            >
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Nome"
                            name="nome"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor, insira um nome!',
                                }
                            ]}
                        >
                            <Input placeholder="Digite o Nome do Modulo" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Ativo"
                            name="ativo"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor, informe este campo!',
                                }
                            ]}
                        >
                            <Select placeholder="Selecione">
                                <Select.Option value="1">Ativo</Select.Option>
                                <Select.Option value="0">Inativo</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="Possui Menu"
                            name="possuiMenu"
                            rules={[
                                {
                                    required: true,
                                    message: 'Por favor, informe este campo!',
                                }
                            ]}
                        >
                            <Select placeholder="Selecione">
                                <Select.Option value="1">Sim</Select.Option>
                                <Select.Option value="0">Não</Select.Option>
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Form.Item
                            label="URL"
                            name="navegarURL"                           
                        >
                            <Input placeholder="Digite a URL" />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Button className="button-pre-cadastro" type="primary" htmlType="submit">
                        Salvar
                    </Button>
                </Form.Item>
            </Form>
        </Modal >
    );
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
})

const mapDispatcToProps = (dispatch: any) => bindActionCreators(ModalStatusAction, dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(ModalModulo);